import { QueryFeature } from '../../../config/queryClient';

enum QueryKey {
  Newsfeed = 'Newsfeed',
  UnreadNewsCount = 'UnreadNewsCount',
}

export const newsfeedQueryKeys = {
  newsfeed: (clientId: string) => [QueryFeature.Newsfeed, QueryKey.Newsfeed, clientId],

  unreadNewsCount: (clientId: number) => [
    QueryFeature.Newsfeed,
    QueryKey.UnreadNewsCount,
    clientId,
  ],
};
